<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        computed: {
            ...mapState([
                'classSelectors',
            ]),
            ...mapState('components',[
                'componentsData',
                'componentsManagerInitFlag',
                'componentsManagerWrapper',
                'componentStates',
                'registeredComponents',
                'componentTypesMapping'
            ]),
        },
        methods: {
            ...mapActions('components',[
                'setComponentsManagerInitFlag',
                'registerComponent',
            ]),
            parseWrapper () {

                let components = this.componentsManagerWrapper.querySelectorAll("." + this.classSelectors.componentNode);

                if (this.componentsManagerWrapper.classList.contains(this.classSelectors.componentNode)) {
                    this.initComponent(this.componentsManagerWrapper);
                }

                components.forEach(component => this.initComponent(component));

            },
            initComponent (componentNode) {


                let componentId = componentNode.id;
                let sameIdFound = false;
                let registrationData = {};
                let componentTypeAttribute = componentNode.getAttribute("data-node-type");

                if (componentId) {

                    this.registeredComponents.map ( registeredComponent => {
                        if (registeredComponent.componentId === componentId) {
                            sameIdFound = true;
                        }
                    });

                    //skip already registered elements
                    if (sameIdFound && this.componentStates[componentId]) {
                        this.componentStates[componentId].findMyNode(); //if class is already initialised for this element just re-sync node context for safe precaution during html manipulation and manager reinitialisation
                        return;
                    } else {
                        registrationData["componentId"] = componentId;
                    }
                } else {
                    registrationData["tempId"] = window.createTimeID(); //create a temp ID until a class is initialised which in turn will overwrite the tempId
                }

                registrationData["componentNode"] = componentNode;
                registrationData["componentType"] = componentTypeAttribute;

                this.registerComponent(registrationData);
            }
        },
        watch: {
            componentsManagerInitFlag:  {
                immediate: true,
                handler () {
                    if (this.componentsManagerWrapper && this.componentsManagerInitFlag) {
                        this.parseWrapper();
                        this.setComponentsManagerInitFlag(false);
                    }
                }
            }
        }
    }
</script>
